/*
 * @Author: Girish Akhare
 * @Date: 2021-06-30 18:40:18
 * @Last Modified by: Girish Akhare
 * @Last Modified time: 2022-04-22 10:53:18
 */

import {
  FiltersDetail,
  OrderFileterDetail,
  UserDetail,
  UserToken,
  ApplianceList,
  WebPreferences,
  Firm
} from 'app/modules/chart/interface/interfaces';

export enum Positions {
  POSITION_0 = 'Position 0',
  POSITION_1 = 'Position 1',
  POSITION_2 = 'Position 2',
  POSITION_3_ROOT = 'Position 3 (Root)',
  POSITION_3_BD = 'Position 3 (BD)',
  POSITION_4 = 'Position 4'
}

export enum PositionsIds {
  POSITION_0 = 0,
  POSITION_1 = 1,
  POSITION_2 = 2,
  POSITION_3 = 3,
  POSITION_4 = 4
}

export enum UserStatus {
  NEW = 'New',
  PENDING = 'Pending',
  ACTIVE = 'Active',
  IN_ACTIVE = 'Inactive'
}

export interface User {
  userId: string;
  status: string;
  firstName: string;
  lastName: string;
  middleName: string;
  email: string;
  crd: string;
  phone: string;
  divisionId: string;
  divisionName: string;
  teamId: string;
  positionId: number;
  applianceId: string;
  junctionId: string;
  sendEmail: boolean;
  modifyTimestamp: string;
  createTimestamp: string;
  activateTimestamp: string;
}

export class VerifyEmailDTO {
  id: number;
  email: string;
  reason: string;
  isEmailValid: boolean;
}

export interface Position {
  name: string;
  id: number;
}

export interface UserCsvFileStats {
  fileID: number;
  originalFilename: string;
  uploadDateTime: number;
  user: {
    firstName: string;
    lastName: string;
    avatarImage: string;
    emailId: string;
    positionId: number;
    junctionId: number;
  };
  totalEntries: number;
  failedEntries: number;
  progressPercentage: number;
  commitStatus: string; // "QUEUED", "VALIDATING", "ERROR", "PENDING", "PROCESSING", "COMPLETE", "CANCELLED"
}

export interface UserCsvFileStatsListDto {
  data: Array<UserCsvFileStats>;
}

export enum AddUserInputField {
  USER_ID = 'User ID',
  STATUS = 'Status',
  FIRST_NAME = 'First Name',
  LAST_NAME = 'Last Name',
  MIDDLE_NAME = 'Middle Name',
  EMAIL = 'Email',
  CRD = 'CRD Number',
  PHONE = 'Phone',
  DIVISION_ID = 'Division ID',
  DIVISION_NAME = 'Division Name',
  TEAM_ID = 'Team ID',
  POSITION_ID = 'Position ID',
  APPLIANCE_ID = 'Account ID',
  JUNCTION_ID = 'Junction ID',
  CREATED_DATE = 'Created Date',
  MODIFIED_DATE = 'Modified Date',
  ACTIVATED_DATE = 'Activated Date'
}

export interface ReduxState {
  userReducer: UserDetail;
  userTokenReducer: UserToken;
  filterReducer: FiltersDetail;
  orderFilterReducer: OrderFileterDetail;
  applianceReducer: ApplianceList;
  selectedApplianceReducer: Firm;
  preferencesReducer: WebPreferences;
}

export interface ReduxAction<T> {
  type: ReduxType;
  payload: T;
}

export enum ReduxType {
  PREFERENCES,
  GET_USER,
  GET_TOKEN,
  GET_USERS,
  USER_DEFAULT,
  COUNTER,
  FILTER_TABLE,
  OREDER_TABLE,
  APPLIANCE_LIST,
  SELECTED_APPLIANCE_ID
}
